module.exports = __webpack_public_path__ + "img/6_4.5c13f44c.png";